import { render, staticRenderFns } from "./compublish.vue?vue&type=template&id=f9af0b2e&"
import script from "./compublish.vue?vue&type=script&lang=js&"
export * from "./compublish.vue?vue&type=script&lang=js&"
import style0 from "./compublish.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports